module.exports = __webpack_public_path__ + "static/media/thibaudbonnevial.bbcbf7f4.jpg";